import * as swcHelpers from '@swc/helpers';
import CmsAccordion from './containers/Accordion/Accordion.js';
import Article from './containers/Article/Article.js';
import CmsBanner from './containers/Banner/Banner.js';
import CmsBannerCollection from './containers/BannerCollection/BannerCollection.js';
import BlogCollection from './containers/BlogCollection/BlogCollection.js';
import BlogOverview from './containers/BlogOverview/BlogOverview.js';
import BrandCollection from './containers/BrandCollection/BrandCollection.js';
import BrandList from './containers/BrandList/BrandList.js';
import CmsCarousel from './containers/Carousel/Carousel.js';
import Document from './containers/Document/Document.js';
import Faq from './containers/Faq/Faq.js';
import Heading from './containers/Heading/Heading.js';
import IconList from './containers/IconList/IconList.js';
import CmsIframe from './containers/Iframe/Iframe.js';
import Newsletter from './containers/Newsletter/Newsletter.js';
import NotificationBar from './containers/NotificationBar/NotificationBar.js';
import Olapic from './containers/Olapic/Olapic.js';
import CmsEmpty from './containers/Empty/Empty.js';
import PolicyBar from './containers/PolicyBar/PolicyBar.js';
import ProductCatalog from './containers/ProductCatalog/ProductCatalog.js';
import Promotion from './containers/Promotion/Promotion.js';
import RichText from './containers/RichText/RichText.js';
import CmsSeo from './containers/Seo/Seo.js';
import SpotlightedStores from './containers/SpotlightedStores/SpotlightedStores.js';
import CmsVideo from './containers/Video/Video.js';
import CmsWidget from './containers/Widget/Widget.js';
import RecentlyViewedProducts from './containers/RecentlyViewedProducts/RecentlyViewedProducts.js';

const defaultComponentDefinitions = {
    Accordion: CmsAccordion,
    Article: Article,
    Banner: CmsBanner,
    'Banner collection': CmsBannerCollection,
    'Blog Collection': BlogCollection,
    'Blog Overview': BlogOverview,
    'Brand collection': BrandCollection,
    'Brand List': BrandList,
    Carousel: CmsCarousel,
    Document: Document,
    FAQ: Faq,
    Heading: Heading,
    'Icon-Link List': IconList,
    IFrame: CmsIframe,
    Newsletter: Newsletter,
    'Notification bar': NotificationBar,
    'Olapic Widget': Olapic,
    Page: CmsEmpty,
    'Policy bar': PolicyBar,
    'Product catalog v2': ProductCatalog,
    'Promotion Algolia': Promotion,
    Promotion: Promotion,
    'Rich Text': RichText,
    Seo: CmsSeo,
    'Spotlighted stores': SpotlightedStores,
    Translation: CmsAccordion,
    Video: CmsVideo,
    Widget: CmsWidget,
    'Recently viewed products': RecentlyViewedProducts
};
function extendComponentDefinitions(definitionsToAdd) {
    return swcHelpers.objectSpread({}, defaultComponentDefinitions, definitionsToAdd);
}

export { defaultComponentDefinitions, extendComponentDefinitions };
//# sourceMappingURL=component-definitions.js.map
